import script from "./DashboardStocuri.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardStocuri.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardStocuri.vue?vue&type=style&index=0&id=c3d641ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3d641ae"]])

export default __exports__